import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
import { useCommonDialog } from '@/component-create/utils/hooks';
import { toast } from '@/utils/message';
import MenuSelect from '@/views/components/MenuSelect.vue';
import { genMenuAuth } from '../../api/code-gen';

import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'GenMenuAuth',
  setup(__props, {
    expose: __expose
  }) {
    const dialogRef = useCommonDialog('dialogRef');
    const menu = ref({
      generating: false
    });
    const form = ref({
      loading: false,
      rules: {
        parentMenuId: [{
          required: true,
          message: '请选择上级菜单',
          trigger: 'blur'
        }]
      }
    });
    const select = ref({
      options: [],
      selected: null
    });
    const business = ref({
      parentMenuId: null
    });
    function handleGenerate() {
      if (menu.value.generating) {
        return;
      }
      menu.value.generating = true;
      if (business.value.parentMenuId === 0) {
        business.value.parentMenuId = null;
      }
      genMenuAuth(business.value).then(() => {
        toast.success('菜单/权限生成成功');
        dialogRef.close();
      }).finally(() => {
        menu.value.generating = false;
      });
    }
    function handleCancel() {
      dialogRef.close();
    }
    function handleParentMenuSelect(menu) {
      select.value.selected = menu;
    }
    function show(bus) {
      business.value = bus;
      dialogRef.open();
    }
    __expose({
      handleParentMenuSelect,
      show
    });
    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_x_common_dialog = _resolveComponent("x-common-dialog");
      return _openBlock(), _createBlock(_component_x_common_dialog, {
        ref_key: "dialogRef",
        ref: dialogRef,
        title: "生成菜单/权限",
        closeable: !_unref(menu).generating,
        width: "20%"
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: handleCancel
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: _unref(menu).generating,
          onClick: handleGenerate
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("生成")])),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: _unref(business),
          loading: _unref(form).loading,
          "label-width": "80px",
          disabled: _unref(menu).generating
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "上级菜单",
                prop: "parentMenuId"
              }, {
                default: _withCtx(() => [_createVNode(MenuSelect, {
                  modelValue: _unref(business).parentMenuId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(business).parentMenuId = $event),
                  menu: false
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "loading", "disabled"])]),
        _: 1
      }, 8, ["closeable"]);
    };
  }
});